module.exports = __webpack_public_path__ + "img/c8e936cd7a34fdc10c75071fa219ef4f.png";